import {Component, ComponentRef, inject} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  NgForm,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {type CanDeactivateFn} from '@angular/router';
import {App} from '@app/app';
import {UnsavedDataComponent} from '@app/dialogs/unsaved-data/unsaved-data.component';
import {FormlyForm} from '@ngx-formly/core';
import {lastValueFrom} from 'rxjs';

export const unsavedDataGuard: CanDeactivateFn<
  Component & {
    objectName: string;
  }
> = async (component, _currentRoute, _currentState, _nextState) => {
  if ((component as any).__skipUnsavedGuard) return true;
  const matDialog = inject(MatDialog);
  let dirty = false;

  for (const propName in component) {
    let prop = component[propName];
    if (prop instanceof ComponentRef) {
      prop = prop.instance;
    }
    if (prop instanceof FormlyForm) {
      prop = prop.form;
    }
    if (
      prop instanceof NgForm ||
      prop instanceof FormControl ||
      prop instanceof FormGroup ||
      prop instanceof FormArray ||
      prop instanceof UntypedFormControl ||
      prop instanceof UntypedFormGroup ||
      prop instanceof UntypedFormArray
    ) {
      dirty ||= prop.dirty && prop.touched;
    }
  }

  if (dirty) {
    if (matDialog.openDialogs.some(dlgRef => dlgRef.componentRef?.componentType === UnsavedDataComponent)) {
      App.suppressGuardRejectionMessage = true;
      return false;
    }
    const assent = await lastValueFrom(
      matDialog.open(UnsavedDataComponent, {data: {macguffin: component.objectName}}).afterClosed(),
    );
    if (!assent) {
      App.suppressGuardRejectionMessage = true;
    }
    return !!assent;
  } else {
    return true;
  }
};
